import CellProducerScore from './CellProducerScore';

export default CellProducerScore;
